import React from 'react';
import './ContactsPage.css';

function ContactsPage() {
  const contacts = [
    {
      meeting: 'APC',
      people: [
        { name: 'Jing Zhang', email: 'jing.zhang@cisac.org' },
        { name: 'Eleonora De Sá Barros', email: 'eleonora.desabarros@cisac.org' }
      ]
    },
    {
      meeting: 'CAF',
      people: [
        { name: 'Miriam Orozco', email: 'miriam.orozco@cisac.org' },
        { name: 'Nesrine Rabah', email: 'nesrine.rabah@cisac.org' }
      ]
    },
    {
      meeting: 'APC/CLC',
      people: [
        { name: 'Jing Zhang', email: 'jing.zhang@cisac.org' },
        { name: 'Goodness Obioha', email: 'goodness.obioha@cisac.org' }
      ]
    },
    {
      meeting: 'APMA',
      people: [
        { name: 'Jing Zhang', email: 'jing.zhang@cisac.org' },
        { name: 'Goodness Obioha', email: 'goodness.obioha@cisac.org' }
      ]
    },
    {
      meeting: 'DLVRG',
      people: [
        { name: 'Eleonora De Sá Barros', email: 'eleonora.desabarros@cisac.org' }
      ]
    },
    {
      meeting: 'VARG',
      people: [
        { name: 'Eleonora De Sá Barros', email: 'eleonora.desabarros@cisac.org' }
      ]
    },
    {
      meeting: 'BIEM MC',
      people: [
        { name: 'Orsolya Fussi-Nagy', email: 'orsolya.fussi-nagy@cisac.org' }
      ]
    },
    {
      meeting: 'BIEM GA',
      people: [
        { name: 'Orsolya Fussi-Nagy', email: 'orsolya.fussi-nagy@cisac.org' }
      ]
    },
    {
      meeting: 'Board',
      people: [
        { name: 'Béatrice Blades', email: 'beatrice.blades@cisac.org' }
      ]
    },
    {
      meeting: 'AAPA',
      people: [
        { name: 'Jing Zhang', email: 'jing.zhang@cisac.org' },
        { name: 'Nesrine Rabah', email: 'nesrine.rabah@cisac.org' }
      ]
    },
    {
      meeting: 'CIAM ExCo',
      people: [
        { name: 'Luisa Luna', email: 'luisa.luna@cisac.org' },
        { name: 'Goodness Obioha', email: 'goodness.obioha@cisac.org' }
      ]
    },
    {
      meeting: 'MRG',
      people: [
        { name: 'Eleonora De Sá Barros', email: 'eleonora.desabarros@cisac.org' }
      ]
    }
  ];

  return (
    <div className="contacts-page">
      {/* Hero Header */}
      <section className="contacts-hero">
        <div className="container">
          <h1>CONTACTS</h1>
          <p>Feel free to contact us if you have any questions.</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="section contacts-content">
        <div className="container">
          {/* Registration & Accommodation */}
          <div className="contact-card-main">
            <h2>Registration & Accommodation</h2>
            <div className="contact-info">
              <p>Email: <a href="mailto:2026ga@cisac.org">2026ga@cisac.org</a></p>
            </div>
          </div>

          {/* Meeting Contacts */}
          <div className="contacts-section">
            <h2>Meeting Contacts</h2>
            <p className="section-description">
              For specific questions about each meeting, please contact the designated person below.
            </p>

            <div className="contacts-list">
              {contacts.map((contact, index) => (
                <div key={index} className="contact-item">
                  <h3>{contact.meeting}</h3>
                  <div className="contact-people">
                    {contact.people.map((person, i) => (
                      <div key={i} className="person">
                        <span className="person-name">{person.name}</span>
                        <a href={`mailto:${person.email}`} className="person-email">
                          {person.email}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactsPage;
